var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-kintell-card-skill-list brand-light-aqua-50 text-center pa-4 paragraph--small"},[_c('span',{staticClass:"no-pointer ma-1 brand-dark-aqua--text"},[_vm._v(_vm._s(_vm.skillSets))])])}
var staticRenderFns = []

export { render, staticRenderFns }